<template>
    <div>
        <CurriculumByDocumentoIdentidad :pDocumentoIdentidad="$route.params.pDocumentoIdentidad" :pRol="$route.params.pRol"/>
    </div>
</template>
<script>
import CurriculumByDocumentoIdentidad from '@/components/PRI/CurriculumByDocumentoIdentidad'

export default {
    name: 'CurriculumByDocumentoIdentidadView',
    components: {
        CurriculumByDocumentoIdentidad
    },
}
</script>
<style scoped>
    .portrait {
        margin: 0 auto;
        max-width: 800px;
        width: 100%;
    }
</style>
